/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebhint2Inputs */

const en_placewebhint2 = /** @type {(inputs: Placewebhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing is saved until you have checked everything.`)
};

const de_placewebhint2 = /** @type {(inputs: Placewebhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeichert wird erst, wenn du alles geprüft hast.`)
};

/**
* | output |
* | --- |
* | "Nothing is saved until you have checked everything." |
*
* @param {Placewebhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebhint2 = /** @type {((inputs?: Placewebhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebhint2(inputs)
	return de_placewebhint2(inputs)
});
export { placewebhint2 as "placeWebHint" }